import {
	getController,
	type HpRequestOptional,
	apiService as Service,
} from '@/services/service'

const url = 'logins'

export const loginService = {
	...getController<Api.Login>(url),
	indexScope: (
		scope: Api.LoginScope = 'lastSevenDays',
		data?: HpRequestOptional
	) =>
		Service.get<Api.Collection<Api.LoginResourceScoped>>({
			url: `${url}/${scope}`,
			...data,
		}),
}

export default loginService
